// extracted by mini-css-extract-plugin
export default {"product_grid":"ProductManager_product_grid__OgYLV","item_wrapper":"ProductManager_item_wrapper__95E5y"};